import React from "react";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";
import classNames from "classnames";
import Box from "@material-ui/core/Box";
import timeoutIndicatorStyles from "../styles/TimeoutIndicator.styles";

const TimeoutIndicator = ({ maxTimeouts, timeouts, reversed }) => {
	const classes = timeoutIndicatorStyles();

	let timeoutList = [];
	const totalTimeouts = Math.max(maxTimeouts, timeouts);

	for (let i = totalTimeouts - 1; i >= 0; i -= 1) {
		timeoutList.push(
			<FiberManualRecord
				key={reversed ? i : -i}
				className={classNames(classes.enabled, classes.dot, {
					[classes.disabled]: i >= timeouts,
					[classes.extraTimeout]: i >= maxTimeouts
				})}
			/>
		);
	}

	if (reversed) {
		timeoutList = timeoutList.reverse();
	}

	return <Box className={classes.container}>{timeoutList}</Box>;
};

export default TimeoutIndicator;
